<script setup>
import { isTouchDevice } from "common/utils/browser";

const props = defineProps({
  disabled: Boolean
});
</script>

<template>
  <div
    class="artwork-legend"
    :class="{
      'artwork-legend--gray': props.disabled
    }"
    data-testid="artwork-legend"
  >
    {{ isTouchDevice() ? "Tap" : "Click" }} and drag to move up and down.
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/print-settings";

.artwork-legend {
  width: 90%;
  height: 52px;
  position: absolute;
  inset: 0;
  margin: auto;
  background-color: $light-aqua;
  color: $black;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 8px;

  &--gray {
    background-color: $pod-gray-modern-200;
    opacity: 0.5;
  }
}
</style>
